<div  class="fs-20px fw-regular am-clock">
  {{ hora }}:{{ minutos }}
</div>
